import { render, staticRenderFns } from "./orderManege.vue?vue&type=template&id=d7c0c00c&"
import script from "./orderManege.vue?vue&type=script&lang=js&"
export * from "./orderManege.vue?vue&type=script&lang=js&"
import style0 from "./orderManege.vue?vue&type=style&index=0&id=d7c0c00c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports